<script lang="ts" setup>
import { Form, FormField } from '@primevue/forms';
import { ResendForgotPasswordCodeForm } from '~/components/auth/forms/forgot-password';
import { AppButton, AppOtpInput, AppTypography } from '~/components/base';
import useCheckForgotPasswordCode from '~/composables/auth/forgot-password/useCheckForgotPasswordCode';
import { EnterOtp as EnterOtpContent } from '~/utils/contents/auth/forms/ForgotPasswordForm';

const { email } = defineProps<{
  email: string;
}>();

const emit = defineEmits<{
  success: [];
}>();
const modelValue = defineModel<string>();

const { loading, form, errors, resolver, submit } =
  useCheckForgotPasswordCode();

const canSubmit = computed(() => {
  return (
    form.value.otp &&
    String(form.value.otp).length === EnterOtpContent.fields.otp.length
  );
});

const subtitleParts = computed(() => {
  const text = EnterOtpContent.subtitle;
  const parts = text.split('<EMAIL>');
  return {
    before: parts[0] || '',
    after: parts[1] || '',
  };
});

const onFormSubmit = async ({ valid }: { valid: boolean }): Promise<void> => {
  if (!valid) return;

  const result = await submit(email, false);
  if (result) {
    modelValue.value = form.value.otp;
    emit('success');
  }
};
</script>

<template>
  <Form
    :resolver="resolver"
    class="enter-otp-form"
    data-testid="enter-otp-form"
    @submit="onFormSubmit"
  >
    <div class="enter-otp-form__header mb-8 text-center">
      <AppTypography type="title-4" variant="h4" class="mb-2">{{
        EnterOtpContent.title
      }}</AppTypography>
      <AppTypography type="body">
        {{ subtitleParts.before }}<strong>{{ email }}</strong
        >{{ subtitleParts.after }}
      </AppTypography>
    </div>

    <FormField v-slot="$field" name="otp" class="mb-8">
      <AppOtpInput
        v-model="form.otp"
        :length="EnterOtpContent.fields.otp.length"
        :data-testid="EnterOtpContent.fields.otp.dataTestId"
        :disabled="loading"
        :invalid="$field.invalid || !!errors.otp?.length"
        :error-message="$field.error?.message || errors.otp?.[0]"
      />
    </FormField>

    <ResendForgotPasswordCodeForm
      :email="email"
      class="mb-8"
      data-testid="resend-form"
    />

    <AppButton
      type="submit"
      class="w-full"
      :data-testid="EnterOtpContent.actions.submitButton.dataTestId"
      :disabled="loading || !canSubmit"
      :loading="loading"
      :label="EnterOtpContent.actions.submitButton.label"
    />
  </Form>
</template>

<style lang="scss" scoped>
.enter-otp-form {
}
</style>
